import { ActionButton, useTheme } from '@fluentui/react';
import React from 'react';

interface IDetailSummaryProps {
  readonly title: string;
  readonly isExpanded: boolean;
  /**
   * Identify the expandable action button for accessibility purpose. i.e. aria-labelledby attribute
   */
  readonly actionButtonId: string;
  /**
   * Identify the details content for accessibility purpose. i.e. aria-controls attribute
   */
  readonly contentId: string;
  readonly onClick: () => void;
}

export const DetailsSummary: React.FC<IDetailSummaryProps> = ({
  title,
  isExpanded,
  actionButtonId,
  contentId,
  onClick,
}) => {
  const theme = useTheme();
  const textColor = theme.palette.themePrimary;

  return (
    <ActionButton
      id={actionButtonId}
      aria-controls={contentId}
      aria-expanded={isExpanded}
      iconProps={{ iconName: isExpanded ? 'ChevronUp' : 'ChevronDown' }}
      onClick={onClick}
      styles={{
        root: {
          color: textColor,
        },
        labelHovered: {
          textDecoration: 'underline',
        },
        icon: {
          color: textColor,
          marginLeft: 0,
          marginRight: 6,
        },
      }}
    >
      {title}
    </ActionButton>
  );
};
